(function () {
  if (typeof window === 'undefined') return;

  var REQUEST_EVENT = 'cart:add-request';
  var RESULT_EVENT = 'cart:add-result';
  var RESULT_TIMEOUT_MS = 10000;

  function toPositiveInt(value, fallbackValue) {
    var parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) {
      return fallbackValue;
    }
    return Math.floor(parsed);
  }

  function parseProperties(formData) {
    var properties = {};
    var hasProperties = false;

    formData.forEach(function (value, key) {
      var match = /^properties\[(.+)\]$/.exec(key);
      if (!match || typeof value !== 'string') return;
      properties[match[1]] = value;
      hasProperties = true;
    });

    return hasProperties ? properties : undefined;
  }

  function buildSingleItemPayload(formData) {
    var id = toPositiveInt(formData.get('id'), null);
    if (!id) return [];

    var quantity = toPositiveInt(formData.get('quantity'), 1);
    var item = {
      id: id,
      quantity: quantity,
    };
    var properties = parseProperties(formData);
    var sellingPlan = toPositiveInt(formData.get('selling_plan'), null);

    if (properties) {
      item.properties = properties;
    }
    if (sellingPlan) {
      item.selling_plan = sellingPlan;
    }

    return [item];
  }

  function buildBatchItemsPayload(formData) {
    var ids = formData.getAll('items[][id]');
    if (!ids.length) return [];

    var quantities = formData.getAll('items[][quantity]');
    var items = [];

    ids.forEach(function (rawId, index) {
      var id = toPositiveInt(rawId, null);
      var quantity = toPositiveInt(quantities[index], 1);
      if (!id || !quantity) return;
      items.push({
        id: id,
        quantity: quantity,
      });
    });

    return items;
  }

  function normalizeCartAddForm(form) {
    var formData = new FormData(form);
    var batchItems = buildBatchItemsPayload(formData);
    return {
      formData: formData,
      items: batchItems.length > 0 ? batchItems : buildSingleItemPayload(formData),
    };
  }

  function ensureBridgeReady(source) {
    if (document.documentElement.dataset.tvCartCapabilityReady === 'true') {
      return Promise.resolve(true);
    }
    if (!window.tvInteractions) {
      return Promise.resolve(false);
    }

    window.tvInteractions.preload({ kind: 'cart', source: source || 'theme-add' });
    return new Promise(function (resolve) {
      var settled = false;
      var finish = function (ready) {
        if (settled) return;
        settled = true;
        window.removeEventListener('tv:cart-capability-ready', onReady);
        window.clearTimeout(timeoutId);
        resolve(ready);
      };
      var onReady = function () { finish(true); };
      var timeoutId = window.setTimeout(function () { finish(false); }, 1500);
      window.addEventListener('tv:cart-capability-ready', onReady, { once: true });
    });
  }

  function buildRequestId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'cart-add-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function waitForAddResult(requestId) {
    return new Promise(function (resolve) {
      var timeoutId = null;
      var handleResult = function (event) {
        var detail = event && event.detail;
        if (!detail || detail.requestId !== requestId) return;
        window.removeEventListener(RESULT_EVENT, handleResult);
        if (timeoutId) {
          window.clearTimeout(timeoutId);
        }
        resolve(detail);
      };

      timeoutId = window.setTimeout(function () {
        window.removeEventListener(RESULT_EVENT, handleResult);
        resolve({
          requestId: requestId,
          ok: false,
          errorCode: 'BRIDGE_TIMEOUT',
          errorMessage: (window.cartStrings && window.cartStrings.error) || 'Cart error',
        });
      }, RESULT_TIMEOUT_MS);

      window.addEventListener(RESULT_EVENT, handleResult);
    });
  }

  async function request(params) {
    var normalized = normalizeCartAddForm(params.form);
    if (!normalized.items.length) {
      return {
        ok: false,
        transport: 'react',
        errorCode: 'INVALID_ADD_REQUEST',
        errorMessage: (window.cartStrings && window.cartStrings.error) || 'Cart error',
      };
    }

    if (!(await ensureBridgeReady(params.source))) {
      return params.legacyRequest(normalized);
    }

    var requestId = buildRequestId();
    var resultPromise = waitForAddResult(requestId);
    window.dispatchEvent(new CustomEvent(REQUEST_EVENT, {
      detail: {
        requestId: requestId,
        items: normalized.items,
        source: params.source,
      },
    }));

    var result = await resultPromise;
    return Object.assign({ transport: 'react' }, result);
  }

  window.__FIRST_PARTY_CART_ADD__ = {
    normalizeCartAddForm: normalizeCartAddForm,
    request: request,
  };
})();
